var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHorizonDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 21,
    viewBox: "0 0 8 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55777 3.41562H4.99977V0.557618H7.55777V3.41562ZM7.55777 7.70062H4.99977V4.84362H7.55777V7.70062ZM7.55777 11.9856H4.99977V9.12862H7.55777V11.9856ZM7.55777 16.2716H4.99977L4.99977 13.4146H7.55777L7.55777 16.2716ZM7.55777 20.5576H4.99977V17.7006H7.55777V20.5576ZM2.99877 3.41562H0.441772L0.441772 0.557618H2.99877V3.41562ZM2.99877 7.70062H0.441772L0.441772 4.84362H2.99877V7.70062ZM2.99877 11.9856H0.441772L0.441772 9.12862H2.99877L2.99877 11.9856ZM2.99877 16.2716H0.441772L0.441772 13.4146H2.99877V16.2716ZM2.99877 20.5576H0.441772L0.441772 17.7006H2.99877V20.5576Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 7.116,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.441772 20.5576)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHorizonDrag);
export default __webpack_public_path__ + "static/media/IconHorizonDrag.68bd940b.svg";
export { ForwardRef as ReactComponent };